import { useEffect, useState } from "react";
import { TDataDiversificacion } from "../../../../services/OmniaService";
import { MetricasResumenCardConverter } from "../../Utils/MetricasResumenCardConverter";
import TableDiversificacion from "../../Component/TableDIversificacion/TableDiversificacion";
import { FormatDataWaterfall } from "../../../Portfolios/File/Util/FormatDataWaterfall";
import { TDiversCartWaterfallModel } from "../../../Portfolios/File/types/DiversificacionCarteraTypes";
import HighchartWaterfallOverlap from "../../../../components/HighChart_Waterfall/HighchartWaterfallOverlap";
import { FormatWaterfallModel } from "../../Utils/FormatWaterfallModel";
import PieHighstock from "../../../../components/Highstock/PieHighstock";
import { FormatToPieChart } from "../../Utils/FormatToPieChart";
import MiniCardsDoubleData, { TSectionDouble } from "../../../../components/MiniCards/MiniCardsDoubleData";

export type TDiversificacionSimulacionData = {
    original: TDataDiversificacion;
    nuevo: TDataDiversificacion;
}

type TDiversificacionSimulacionProps = {
    data: TDiversificacionSimulacionData
}

const BASE_CLASS = "diversificacionSimulacion";

const DiversificacionSimulacion = ({ data }: TDiversificacionSimulacionProps) => {

    const [metricas, setMetricas] = useState<TSectionDouble[]>();
    
    const originalPieChart = FormatToPieChart({
        activo1: data.original.graficos.tarta_exterior,
        activo1y2: data.original.graficos.tarta_interior
    });

    const nuevoPieChart = FormatToPieChart({
        activo1: data.nuevo.graficos.tarta_exterior,
        activo1y2: data.nuevo.graficos.tarta_interior
    });

    useEffect(() => {
        const callToDiversificacion = async () => {
            const metricasFormated: TSectionDouble[] = MetricasResumenCardConverter({
                original: data.original.metricas_resumen,
                nuevo: data.nuevo.metricas_resumen
            });
            setMetricas(metricasFormated);
        };
        callToDiversificacion();
    }, [data]);

    const nuevoWaterFall: TDiversCartWaterfallModel[] = FormatWaterfallModel(data.nuevo.graficos.waterfall)

    const originalWaterFall: TDiversCartWaterfallModel[] = FormatWaterfallModel(data.original.graficos.waterfall)

    const nuevoWaterfallData = FormatDataWaterfall({dataWaterfall: nuevoWaterFall})
    const origenWaterfallData = FormatDataWaterfall({dataWaterfall: originalWaterFall})

    return (
        <div className={BASE_CLASS}>
            <MiniCardsDoubleData sections={metricas ?? []} />
            <div className={`${BASE_CLASS}__graphs__container`}>
                <div className={`${BASE_CLASS}__waterfall__container`}>
                    <HighchartWaterfallOverlap name="Waterfall de Riesgo" nuevoData={nuevoWaterfallData} originalData={origenWaterfallData} />
                </div>
                <div className={`${BASE_CLASS}__piecharts__container`}>
                    <div className={`${BASE_CLASS}__piecharts__box`}>
                        <h4>Original</h4>
                        <PieHighstock chartSerie={originalPieChart} showSubcategories={true} />
                    </div>
                    <div className={`${BASE_CLASS}__piecharts__box`}>
                        <h4>Nuevo</h4>
                        <PieHighstock chartSerie={nuevoPieChart} showSubcategories={true} />
                    </div>
                </div>
            </div>
            <div className={`${BASE_CLASS}__table__container`}>
                <TableDiversificacion tableData={data.original.tabla_detalle} title="Original" />
                <TableDiversificacion tableData={data.nuevo.tabla_detalle} title="Nuevo" />
            </div>
        </div>
    )
}

export default DiversificacionSimulacion;